import React, { useEffect, useState, useMemo, useCallback } from 'react';
import { createCustomerRoot, getContactItemKey, getSelectedItemBySelectOrg, getTeamMembers, getTeams, isOrg, transContactModel2ContactItem, transEntityOrg2OrgItem, transOrgItem2TreeNode, transServerCustomer2TreeNode, transTreeLeaf, transTreeNode, } from '@web-common/components/util/contact';
import useMsgCallback from '@web-common/hooks/useMsgCallback';
import { selectBtnNameMap } from '@web-common/components/UI/SiriusContact/tree/BaseTree';
import { api, apis, ProductTagEnum, util, } from 'api';
import { getValidEmail, StaticNodeKey, StaticRootNodeKey, updateOrgTreeDataV2 } from '@web-common/utils/contact_util';
import useContactItemEffect from '../useContactItemEffect';
import styles from './index.module.scss';
import classnames from 'classnames';
import { useDebounceEffect } from 'ahooks';
import { MemberList } from '@web-contact/component/MemberList/MemberList';
import Tree from '@web-mail/common/components/VListTree/VListTree';
import { Space, Tooltip, Button, Skeleton } from 'antd';
import Checkbox from '../Checkbox';
import AvatarTag from '@web-common/components/UI/Avatar/avatarTag';
import ProductAuthTag from '@web-common/components/UI/ProductAuthTag/ProductAuthTag';
import EyeOutlined from '@ant-design/icons/EyeOutlined';
import InfoCircleOutlined from '@ant-design/icons/InfoCircleOutlined';
import MailMainIcon from '@web-common/components/UI/Icons/svgs/MailMain';
import Mail163Icon from '@web-common/images/mail_163.png';
import MailQqIcon from '@web-common/images/mail_qq.png';
import MailOutlookIcon from '@web-common/images/mail_outlook.png';
import MailQiyeQQIcon from '@web-common/images/mail_qiye_qq.png';
import MailGmailIcon from '@web-common/images/mail_gmail.png';
import MailOtherIcon from '@web-common/components/UI/Icons/svgs/MailOther';
import PersonalMark from '@web-common/components/UI/SiriusContact/personalMark/mark';
import { transTreeName, isCurrentUser } from './data';
import lodashGet from 'lodash/get';
import useCreateCallbackForEvent from '@web-common/hooks/useCreateCallbackForEvent';
import { doGetCustomerContactListById, doGetMyCustomerList } from '@web-common/state/reducer/contactReducer';
import { useGetProductAuth } from '@web-common/hooks/useGetProductAuth';
import useDebounceForEvent from '@web-common/hooks/useDebounceForEvent';
const contactApi = api.requireLogicalApi(apis.contactApiImpl);
const sysApi = api.getSystemApi();
const loggerApi = api.requireLogicalApi(apis.loggerApiImpl);
const dataTrackerApi = api.requireLogicalApi(apis.dataTrackerApiImp);
const loadTimeout = 3 * 1000;
const mailIconList = new Map([
    ['NeteaseQiYeMail', React.createElement(MailMainIcon, null)],
    ['163Mail', React.createElement("img", { style: { width: 16, height: 16 }, src: Mail163Icon })],
    ['Gmail', React.createElement("img", { src: MailGmailIcon, style: { objectFit: 'contain', width: 16, height: 16 } })],
    ['Outlook', React.createElement("img", { src: MailOutlookIcon, style: { width: 16, height: 16 } })],
    ['TencentQiye', React.createElement("img", { src: MailQiyeQQIcon, style: { width: 16, height: 16 } })],
    ['QQMail', React.createElement("img", { style: { width: 16, height: 16 }, src: MailQqIcon })],
    ['Others', React.createElement(MailOtherIcon, null)],
]);
const initTreeDataMap = {
    customer: [
        {
            key: StaticRootNodeKey.CUSTOMER,
            nodeType: 'customer',
            title: transTreeName('customer'),
            isLeaf: false,
            isOrg: true,
            children: [],
        },
    ],
    personal: [
        {
            key: StaticRootNodeKey.PERSON,
            nodeType: 'personal',
            title: transTreeName('personal'),
            isLeaf: false,
            isOrg: true,
            children: [],
        },
    ],
    enterprise: [
        {
            key: StaticRootNodeKey.ENTERPRISE,
            title: transTreeName('enterprise'),
            isLeaf: false,
            isOrg: true,
            nodeType: 'enterprise',
            children: [],
        },
    ],
    team: [
        {
            key: StaticRootNodeKey.TEAM,
            nodeType: 'team',
            isOrg: true,
            title: transTreeName('team'),
            isLeaf: false,
            children: [],
        },
    ],
    recent: [
        {
            key: StaticRootNodeKey.RECENT,
            nodeType: 'recent',
            isOrg: true,
            title: transTreeName('recent'),
            isLeaf: false,
            children: [],
        },
    ],
};
const getNodeDataByKey = (data, key) => {
    let res;
    data.forEach(item => {
        if (!res) {
            if (item.key === key) {
                res = item;
            }
            else if (item.children) {
                res = getNodeDataByKey(item.children, key);
            }
        }
    });
    return res;
};
const transTreeMap2TreeData = (treeDataMap, order) => {
    let arr = [];
    order.forEach(item => {
        const curTreeData = treeDataMap[item];
        arr = arr.concat(curTreeData || []);
    });
    return arr;
};
export const treeRootKey = [
    StaticRootNodeKey.ENTERPRISE,
    StaticRootNodeKey.PERSON,
    StaticRootNodeKey.TEAM,
    StaticRootNodeKey.RECENT,
    StaticRootNodeKey.CUSTOMER,
];
const personalMarkKeyBlackList = [StaticRootNodeKey.PERSON, StaticNodeKey.PERSON_ALL, StaticNodeKey.PERSON_MARK_LIST, StaticNodeKey.PERSON_NO_GROUP];
const AccountTree = props => {
    const { treeWidth, treeHeight, accountRootKey, _account, rootTitle, onContactSelect, defaultSelectList = [], disableCheckList: defaultDisableCheckList, multiple, isIM = true, showAddOrgBtn, showAddTeamBtn, showAddPersonalBtn, showMailListEye, showPersonalMark: showPersonalMarkProp, showNoDataPlaceholder, onExpand, onSelectNode, onInited, onMarked, onContextMenu, activeAccountKey, showContact = true, showAvatar = true, showCheckbox = true, type = ['personal', 'enterprise', 'team', 'recent'], order = ['customer', 'recent', 'personal', 'team', 'enterprise'], useContactId, useOrgUnit, excludeSelf = false, accountType, defaultExpandedKeys, noRelateEnterprise, isSingleAccount = true, titleRenderMap, selectDefaultNodeOnInited, renderTitleSuffix, contactTreeDecorateMap, selectedKeys = [], showOrgMemberNum = false, excludeOrgTypes, } = props;
    const { productVersionInfo: { navigateVersion }, } = useGetProductAuth();
    const showPersonalMark = !(process.env.BUILD_ISEDM || navigateVersion) && showPersonalMarkProp;
    const excludeOrgTypeSet = useMemo(() => new Set(excludeOrgTypes || []), [excludeOrgTypes]);
    const rootKey = useMemo(() => {
        const keys = [...treeRootKey];
        if (accountRootKey) {
            keys.push(accountRootKey);
        }
        return keys;
    }, [accountRootKey]);
    const defaultTreeDataMap = useMemo(() => {
        return type.reduce((ret, item) => {
            ret[item] = initTreeDataMap[item];
            return ret;
        }, {});
    }, [type]);
    const [treeDataMap, setTreeDataMap] = useState(defaultTreeDataMap);
    const [orgModel, setOrgModel] = useState();
    const [personalOrgMap, setPersonalOrgMap] = useState(new Map());
    const [selectedMap, setSelectedMap] = useState(new Map());
    const [disabledMap, setDisabledMap] = useState(new Map());
    const [loading, setLoading] = useState(true);
    const [selectOrgLoading, setSelectOrgLoading] = useState(false);
    const [showMemberList, setShowMemberList] = useState(false);
    const [currentContact, setCurrentContact] = useState();
    const [expandedKeys, setExpandedKeys] = useState(new Set());
    const _defaultExpandedKeys = useMemo(() => {
        return defaultExpandedKeys || (isIM && isSingleAccount ? [StaticRootNodeKey.ENTERPRISE] : []);
    }, []);
    const [decorateRenderMap, setDecorateRenderMap] = useState(contactTreeDecorateMap || new Map());
    const loadCustomerData = useCallback(async (params) => {
        const { loadMore, customerList, page } = await doGetMyCustomerList(params);
        const children = customerList.map(transServerCustomer2TreeNode);
        trackerLoadDataLog('customer', customerList.length);
        return {
            children,
            hasMore: loadMore,
            page,
        };
    }, []);
    const loadCustomerContactData = useCallback(async (params) => {
        const { data, hasMore, page } = await doGetCustomerContactListById(params);
        const children = data.reduce((arr, current) => {
            if (current) {
                arr.push(transTreeLeaf({
                    item: {
                        name: current.name || current.email,
                        email: current.email,
                        id: current.id,
                        type: 'customer',
                        customerRole: 'myCustomer',
                    },
                }));
            }
            return arr;
        }, []);
        return {
            children,
            hasMore,
            page,
        };
    }, []);
    const trackerLoadDataError = useCallback((treeType, message) => {
        dataTrackerApi.track('contact_tree_load_data_error', {
            treeType,
            _account,
            message,
        });
    }, [_account]);
    const trackerLoadDataLog = useCallback((treeType, count) => {
        loggerApi.track('contact_tree_load_data', {
            treeType,
            count,
            _account,
        });
    }, [_account]);
    const transPersonalTree = (params) => {
        const { item, parentKey, useContactId } = params;
        const { id, name, type, emailList } = item;
        if (!useContactId && emailList && emailList.length > 1) {
            return {
                key: 'personal_info_' + (parentKey ? parentKey + '_' : '') + id,
                title: name,
                isLeaf: false,
                isOrg: true,
                nodeType: 'personal_info',
                children: emailList.map(_email => {
                    return {
                        key: id + '&' + _email,
                        title: _email,
                        isLeaf: true,
                        isOrg: false,
                        data: {
                            id,
                            type,
                            email: _email,
                            name: _email,
                        },
                        nodeType: type,
                    };
                }),
            };
        }
        return transTreeLeaf({ item, parentKey });
    };
    const getRecentDataByOrder = async (value) => {
        const emails = value.map(item => {
            return item.accountName;
        });
        const contactModelMap = await contactApi.doGetContactByEmail({ emails, _account });
        const res = [];
        value.forEach(item => {
            const modelList = contactModelMap[item.accountName];
            if (modelList === null || modelList === void 0 ? void 0 : modelList.length) {
                let model;
                modelList.forEach(itemModel => {
                    const cur = transContactModel2ContactItem(itemModel);
                    if (model) {
                        model = getValidEmail(model, cur);
                    }
                    else {
                        model = cur;
                    }
                });
                if (model) {
                    res.push(model);
                }
                else {
                    res.push({
                        name: item.contactName,
                        email: item.accountName,
                        type: 'external',
                    });
                }
            }
            else {
                res.push({
                    name: item.contactName,
                    email: item.accountName,
                    type: 'external',
                });
            }
        });
        return res;
    };
    const getRecentContactList = async (result, force) => {
        let resData;
        if (result) {
            resData = result;
        }
        else {
            resData = await contactApi.getRecentContactList({
                page: 1,
                pageSize: 30,
                conditionType: 1,
                contactType: 1,
                _account,
            }, force);
        }
        if (!resData || resData.length === 0)
            return [];
        const value = [];
        resData.forEach(send => {
            value.push({
                accountName: send.email,
                contactName: send.nickname || '',
            });
        });
        const recentData = await getRecentDataByOrder(value);
        const recentChildren = recentData.map(item => ({
            key: item.email,
            nodeType: 'recent',
            isLeaf: true,
            isOrg: false,
            title: item.name,
            data: item,
        }));
        return recentChildren;
    };
    const initPersonalOrgList = async () => {
        try {
            const { success, data, message } = await contactApi.doGetPersonalOrg({ _account });
            if (success && (data === null || data === void 0 ? void 0 : data.length)) {
                return data;
            }
            if (message) {
                trackerLoadDataError('personalOrgList', getStringMsg(message));
            }
        }
        catch (e) {
            trackerLoadDataError('personalOrgList', getStringMsg(e));
        }
        return [];
    };
    const getStringMsg = (e) => {
        let ret;
        if (typeof e === 'string') {
            ret = e;
        }
        else if (e.message && typeof e.message === 'string') {
            ret = e.message;
        }
        else {
            ret = 'unknown';
        }
        return ret;
    };
    const initPersonalList = async () => {
        let groupMap = new Map();
        try {
            const list = await contactApi.doGetPersonalContact({ _account, needLog: true });
            trackerLoadDataLog('personalList', list === null || list === void 0 ? void 0 : list.length);
            setPersonalOrgMap(_oldMap => {
                const personalMarkList = _oldMap.get(StaticNodeKey.PERSON_MARK_LIST) || new Map();
                list === null || list === void 0 ? void 0 : list.forEach(item => {
                    const { personalOrg, id } = item.contact;
                    const contactItem = transContactModel2ContactItem(item);
                    const allMap = groupMap.get(StaticNodeKey.PERSON_ALL) || new Map();
                    allMap.set(id, contactItem);
                    groupMap.set(StaticNodeKey.PERSON_ALL, allMap);
                    if (personalOrg === null || personalOrg === void 0 ? void 0 : personalOrg.length) {
                        personalOrg.forEach(personalOrgId => {
                            const idMap = groupMap.get(personalOrgId) || new Map();
                            idMap.set(id, contactItem);
                            groupMap.set(personalOrgId, idMap);
                        });
                    }
                    else {
                        const noGroupIdSet = groupMap.get(StaticNodeKey.PERSON_NO_GROUP) || new Map();
                        noGroupIdSet.set(id, contactItem);
                        groupMap.set(StaticNodeKey.PERSON_NO_GROUP, noGroupIdSet);
                    }
                });
                groupMap.set(StaticNodeKey.PERSON_MARK_LIST, personalMarkList);
                return groupMap;
            });
        }
        catch (e) {
            trackerLoadDataError('personalList', getStringMsg(e));
        }
        return groupMap;
    };
    const initPersonalMarkList = useCallback(async () => {
        let list = [];
        try {
            if (showPersonalMark) {
                list = await contactApi.doGetContactPersonalMarkList();
                trackerLoadDataLog('personalMarkList', list.length);
                setPersonalOrgMap(_data => {
                    const m = new Map();
                    list.forEach(item => {
                        item.id && m.set(item.id, item);
                    });
                    const newData = new Map(_data);
                    newData.set(StaticNodeKey.PERSON_MARK_LIST, m);
                    return newData;
                });
            }
        }
        catch (e) {
            trackerLoadDataError('personalMarkList', getStringMsg(e));
        }
        return list;
    }, [showPersonalMark]);
    const initPersonal = async (updateLoadKeys) => {
        let children = [];
        try {
            const [personalOrgList, groupMap] = await Promise.all([initPersonalOrgList(), initPersonalList(), initPersonalMarkList()]);
            if (personalOrgList === null || personalOrgList === void 0 ? void 0 : personalOrgList.length) {
                const personalOrgChildren = personalOrgList.map(item => {
                    const node = transTreeNode(item, !showContact);
                    const nodeChildren = groupMap.get(node.key);
                    if ((nodeChildren === null || nodeChildren === void 0 ? void 0 : nodeChildren.size) && showContact) {
                        node.children = [...nodeChildren.values()].map(leaf => {
                            return transPersonalTree({ item: leaf, useContactId, parentKey: node.key });
                        });
                    }
                    return node;
                });
                children = children.concat(personalOrgChildren);
            }
            const allPersonalChildren = [];
            const allPerosnalMap = groupMap.get(StaticNodeKey.PERSON_ALL);
            const allPersonalSize = (allPerosnalMap === null || allPerosnalMap === void 0 ? void 0 : allPerosnalMap.size) || 0;
            if (allPersonalSize && showContact) {
                allPerosnalMap === null || allPerosnalMap === void 0 ? void 0 : allPerosnalMap.forEach(leaf => {
                    if (!(excludeSelf && isCurrentUser(leaf))) {
                        allPersonalChildren.push(transPersonalTree({ item: leaf, parentKey: StaticNodeKey.PERSON_ALL, useContactId }));
                    }
                });
            }
            children.unshift({
                key: StaticNodeKey.PERSON_ALL,
                title: transTreeName('allPersonal'),
                isLeaf: !showContact && allPersonalChildren.length === 0,
                nodeType: 'personal',
                isOrg: true,
                children: allPersonalChildren,
            });
            const noGroupPerosnalMap = groupMap.get(StaticNodeKey.PERSON_NO_GROUP);
            const noGroupSize = (noGroupPerosnalMap === null || noGroupPerosnalMap === void 0 ? void 0 : noGroupPerosnalMap.size) || 0;
            if (noGroupPerosnalMap && noGroupSize && noGroupSize !== allPersonalSize) {
                let noGroupPersonalChildren = [];
                if (showContact) {
                    noGroupPersonalChildren = [...noGroupPerosnalMap.values()].map(leaf => {
                        return transPersonalTree({ item: leaf, useContactId, parentKey: StaticNodeKey.PERSON_NO_GROUP });
                    });
                }
                children.push({
                    key: StaticNodeKey.PERSON_NO_GROUP,
                    title: transTreeName('noGroupPersonal'),
                    isLeaf: !showContact && noGroupPersonalChildren.length === 0,
                    nodeType: 'personal',
                    isOrg: true,
                    children: noGroupPersonalChildren,
                });
            }
            if (showPersonalMark) {
                children.push({
                    key: StaticNodeKey.PERSON_MARK_LIST,
                    title: transTreeName('markPersonalList'),
                    isLeaf: !showContact,
                    nodeType: 'personal',
                    isOrg: true,
                });
            }
            console.warn('[contact_tree] load initPersonal finish ', _account);
            setLoading(false);
            updateTreeMap('personal', [
                {
                    key: StaticRootNodeKey.PERSON,
                    nodeType: 'personal',
                    title: transTreeName('personal'),
                    isLeaf: false,
                    isOrg: true,
                    children,
                },
            ], updateLoadKeys);
        }
        catch (e) {
            trackerLoadDataError('personal', getStringMsg(e));
        }
    };
    const initEnterprise = async (updateLoadKeys) => {
        try {
            const orgData = await contactApi.doGetContactOrgMap({ _account, isIM });
            setOrgModel(orgData);
            setLoading(false);
            const mainEnterpriseId = sysApi.getCurrentCompanyId(_account);
            const hasRelateOrg = !noRelateEnterprise && lodashGet(orgData, '[-2].children.length', 1) > 1 && (!_account || lodashGet(sysApi.getCurrentUser(), 'id', '') === _account);
            let rootKey = '';
            if (hasRelateOrg) {
                rootKey = '-2';
            }
            else {
                rootKey =
                    Object.keys(orgData).find(key => {
                        return [`${mainEnterpriseId}_-1`, '-1'].includes(key);
                    }) || '';
            }
            if (lodashGet(orgData, `[${rootKey}].children.length`, 0) === 0) {
                loggerApi.track('pc_contact_orgmap_emptyerror', {
                    rootKey,
                    totalOrgKeys: lodashGet(orgData, `[-2].children`, [])
                        .map(item => {
                        return item.id;
                    })
                        .join(','),
                });
                return;
            }
            const currentOrgChildren = orgData[rootKey];
            const children = currentOrgChildren === null || currentOrgChildren === void 0 ? void 0 : currentOrgChildren.children;
            trackerLoadDataLog('enterprise', (children === null || children === void 0 ? void 0 : children.length) || 0);
            if (children === null || children === void 0 ? void 0 : children.length) {
                const sortedChildren = hasRelateOrg
                    ? [...children].sort((a, b) => {
                        const aIsMain = a.id === '-1' || a.id === `${mainEnterpriseId}_-1` ? 0 : 1;
                        const bIsMain = b.id === '-1' || b.id === `${mainEnterpriseId}_-1` ? 0 : 1;
                        return aIsMain - bIsMain;
                    })
                    : children;
                updateTreeMap('enterprise', [
                    {
                        key: StaticRootNodeKey.ENTERPRISE,
                        nodeType: 'enterprise',
                        title: transTreeName('enterprise'),
                        isLeaf: false,
                        isOrg: true,
                        children: sortedChildren
                            .filter(c => !excludeOrgTypeSet.has(c.type))
                            .map(item => {
                            var _a, _b;
                            if (item.type === 99 && ((_b = (_a = orgData[item.id]) === null || _a === void 0 ? void 0 : _a.children) === null || _b === void 0 ? void 0 : _b.length) === 1 && orgData[item.id].children[0].orgName === item.orgName) {
                                return transTreeNode(orgData[item.id].children[0]);
                            }
                            return transTreeNode(item);
                        }),
                    },
                ], updateLoadKeys);
            }
            else {
                updateTreeMap('enterprise', [], updateLoadKeys);
            }
            console.warn('[contact_tree] load initEnterprise finish', _account, orgData);
        }
        catch (e) {
            trackerLoadDataError('enterprise', getStringMsg(e));
        }
    };
    const initRecent = async (params) => {
        if (!type.includes('recent')) {
            return;
        }
        const { result, updateLoadKeys, force } = params || {};
        let children = [];
        try {
            children = await getRecentContactList(result, force);
            trackerLoadDataLog('recent', children === null || children === void 0 ? void 0 : children.length);
            updateTreeMap('recent', [
                {
                    key: StaticRootNodeKey.RECENT,
                    nodeType: 'recent',
                    title: transTreeName('recent'),
                    isLeaf: false,
                    isOrg: true,
                    children,
                },
            ], updateLoadKeys);
        }
        catch (e) {
            trackerLoadDataError('recent', getStringMsg(e));
        }
    };
    const initTeam = async (updateLoadKeys) => {
        if (!type.includes('team')) {
            return;
        }
        let children = [];
        try {
            const teamList = await getTeams();
            trackerLoadDataLog('team', teamList === null || teamList === void 0 ? void 0 : teamList.length);
            if (teamList === null || teamList === void 0 ? void 0 : teamList.length) {
                children = teamList.map(item => transTreeNode(item, !showContact));
            }
            updateTreeMap('team', [
                {
                    key: StaticRootNodeKey.TEAM,
                    nodeType: 'team',
                    title: transTreeName('team'),
                    isLeaf: false,
                    isOrg: true,
                    children,
                },
            ], updateLoadKeys);
            console.warn('[contact_tree] load initTeam finish', _account, teamList);
        }
        catch (e) {
            trackerLoadDataError('team', getStringMsg(e));
        }
    };
    const initCustomer = async (updateLoadKeys) => {
        if (!type.includes('customer')) {
            return;
        }
        const { children, hasMore, page } = await loadCustomerData({ force: true });
        const customerRoot = createCustomerRoot({
            children,
            hasMore,
            page,
        });
        updateTreeMap('customer', [customerRoot], updateLoadKeys);
    };
    const updateTreeMap = (key, data, updateLoadKeys) => {
        var _a;
        setTreeDataMap(res => (Object.assign(Object.assign({}, res), { [key]: data })));
        if (updateLoadKeys) {
            const expandKey = data[0].key;
            const childrenKey = (_a = data[0].children) === null || _a === void 0 ? void 0 : _a.map(item => item.key);
            expandedKeys.delete(expandKey);
            if (childrenKey === null || childrenKey === void 0 ? void 0 : childrenKey.length) {
                childrenKey.forEach(curKey => {
                    expandedKeys.delete(curKey);
                });
            }
            setExpandedKeys(new Set([...expandedKeys]));
        }
    };
    const _inited = useCallback((type) => {
        var _a;
        loggerApi.track('contact_tree_inited', {
            treeType: type,
        });
        const typeData = treeDataMap[type];
        if (typeData) {
            const typeRootKey = (_a = typeData[0]) === null || _a === void 0 ? void 0 : _a.key;
            if (typeRootKey && _defaultExpandedKeys.includes(typeRootKey)) {
                setExpandedKeys(_set => {
                    _set.add(typeRootKey);
                    return new Set(_set);
                });
            }
        }
    }, [_defaultExpandedKeys]);
    const getInitData = async () => {
        loggerApi.track('contact_tree_init', {
            type,
        });
        const starTime = Date.now();
        const list = [];
        if (type.includes('customer')) {
            list.push(initCustomer().then(() => _inited('customer')));
        }
        if (type.includes('personal')) {
            list.push(initPersonal().then(() => _inited('personal')));
        }
        if (type.includes('team')) {
            list.push(initTeam().then(() => _inited('team')));
        }
        if (type.includes('enterprise')) {
            list.push(initEnterprise().then(() => _inited('enterprise')));
        }
        if (type.includes('recent')) {
            list.push(initRecent().then(() => _inited('recent')));
        }
        await Promise.all(list);
        loggerApi.track('contact_tree_inited_all', {
            type,
            time: Date.now() - starTime + 'ms',
        });
        if (selectDefaultNodeOnInited && (selectedKeys === null || selectedKeys === void 0 ? void 0 : selectedKeys.length)) {
            setTreeDataMap(dataMap => {
                const treeData = transTreeMap2TreeData(dataMap, order);
                const nodeData = getNodeDataByKey(treeData, selectedKeys[0]);
                nodeData && handleSelectNode(nodeData);
                return dataMap;
            });
        }
        onInited && onInited(_account);
    };
    const loadDataTimeoutError = useCreateCallbackForEvent(async () => {
        if (loading || !visibleTree) {
            const [dbOrgCount, dbContactCount] = await Promise.all([contactApi.doGetTableCount('contact'), contactApi.doGetTableCount('org')]);
            const personalAll = personalOrgMap === null || personalOrgMap === void 0 ? void 0 : personalOrgMap.get(StaticNodeKey.PERSON_ALL);
            dataTrackerApi.track('contact_tree_load_data_timeout', {
                enterpriseCount: (orgModel === null || orgModel === void 0 ? void 0 : orgModel.size) || 0,
                personalOrgCount: (personalOrgMap === null || personalOrgMap === void 0 ? void 0 : personalOrgMap.size) || 0,
                personalCount: (personalAll === null || personalAll === void 0 ? void 0 : personalAll.size) || 0,
                dbOrgCount,
                dbContactCount,
                _account,
            });
        }
    });
    const typeKey = useMemo(() => {
        return type ? type.join() : '';
    }, [type]);
    useDebounceEffect(() => {
        getInitData();
        const timer = setTimeout(() => {
            loadDataTimeoutError();
        }, loadTimeout);
        return () => {
            if (timer) {
                clearTimeout(timer);
            }
        };
    }, [typeKey], { wait: 500 });
    useContactItemEffect(defaultSelectList, () => {
        const itemMap = new Map();
        defaultSelectList.forEach(item => {
            const key = isOrg(item) ? item.id : getContactItemKey(item, useContactId);
            itemMap.set(key, item);
        });
        setSelectedMap(itemMap);
    }, useContactId);
    useEffect(() => {
        if (defaultDisableCheckList === null || defaultDisableCheckList === void 0 ? void 0 : defaultDisableCheckList.length) {
            const itemMap = new Map();
            defaultDisableCheckList.forEach(item => {
                const key = isOrg(item) ? item.id : getContactItemKey(item, useContactId);
                itemMap.set(key, item);
            });
            setDisabledMap(itemMap);
        }
    }, [defaultDisableCheckList]);
    useEffect(() => {
        if (accountRootKey) {
            if (activeAccountKey && activeAccountKey === accountRootKey) {
                expandedKeys.add(accountRootKey);
            }
            else if (accountRootKey) {
                expandedKeys.delete(accountRootKey);
            }
            setExpandedKeys(new Set([...expandedKeys]));
        }
    }, [activeAccountKey, isSingleAccount]);
    const refresh = useCallback(async (eventData) => {
        const { syncStatus } = eventData || { syncStatus: {} };
        const needSyncPersonal = (syncStatus === null || syncStatus === void 0 ? void 0 : syncStatus.personalOrg) || (syncStatus === null || syncStatus === void 0 ? void 0 : syncStatus.personal);
        const needSyncOrg = (syncStatus === null || syncStatus === void 0 ? void 0 : syncStatus.org) || (syncStatus === null || syncStatus === void 0 ? void 0 : syncStatus.enterprise);
        const needSyncTeam = syncStatus === null || syncStatus === void 0 ? void 0 : syncStatus.team;
        loggerApi.track('contact_tree_contactNotify', {
            needSyncPersonal,
            needSyncOrg,
            needSyncTeam,
        });
        if (type.includes('personal') && needSyncPersonal) {
            initPersonal(showContact);
        }
        if (type.includes('enterprise') && needSyncOrg) {
            initEnterprise(showContact);
        }
        if (type.includes('team') && needSyncTeam) {
            initTeam(true);
        }
    }, []);
    useMsgCallback('contactNotify', useCreateCallbackForEvent(ev => {
        var _a;
        const currentAccount = _account || ((_a = sysApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id);
        if (ev._account === currentAccount) {
            refresh(ev.eventData);
        }
    }));
    useMsgCallback('contactPersonalMarkNotify', useCreateCallbackForEvent(ev => {
        var _a;
        const currentAccount = _account || ((_a = sysApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id);
        const eventData = ev.eventData;
        if (ev._account === currentAccount && !eventData.noNewMarkData) {
            getPersonalMarkListAndRefresh();
        }
    }));
    useMsgCallback('recentContactNotify', useCreateCallbackForEvent(async (ev) => {
        var _a, _b;
        const currentAccount = _account || ((_a = sysApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id);
        if (ev._account !== currentAccount) {
            return;
        }
        const result = (_b = ev === null || ev === void 0 ? void 0 : ev.eventData) === null || _b === void 0 ? void 0 : _b.result;
        let force = false;
        if (!result) {
            force = true;
        }
        loggerApi.track('contact_tree_recentContactNotify', {
            force,
        });
        initRecent({ result, updateLoadKeys: true, force });
    }));
    useMsgCallback('customerMapChangeNotify', useCreateCallbackForEvent(e => {
        const eventData = e.eventData;
        if (eventData.target === 'myCustomerList') {
            initCustomer(true);
        }
        loggerApi.track('contact_tree_contactEdmNotify');
    }));
    const getPersonalMarkListAndRefresh = useDebounceForEvent(async () => {
        console.error('[debounce] getPersonalMarkListAndRefresh');
        await initPersonalMarkList();
        renderTree();
    }, 1000);
    const handleSelectOrg = async (dataNode) => {
        const { key, nodeType, orgList, children, data } = dataNode;
        const isPersonalOrg = nodeType === 'personal';
        const isTeam = nodeType === 'team';
        let idList = [];
        let selectedList = [];
        if (useOrgUnit) {
            const orgItem = transEntityOrg2OrgItem(data);
            if (multiple) {
                selectedMap.set(key, orgItem);
                setSelectedMap(selectedMap);
                onContactSelect && onContactSelect([...selectedMap.values()], [orgItem]);
            }
            else {
                onContactSelect && onContactSelect([orgItem], [orgItem]);
            }
            return;
        }
        if (selectOrgLoading) {
            return;
        }
        setSelectOrgLoading(true);
        if (isTeam) {
            const memberList = (await getTeamMembers([key], false));
            memberList.forEach(item => {
                if (item.model) {
                    selectedList.push(transContactModel2ContactItem(item.model));
                }
            });
        }
        else if (isPersonalOrg) {
            const personalChildren = children;
            personalChildren === null || personalChildren === void 0 ? void 0 : personalChildren.forEach(item => {
                if (!item.isOrg) {
                    const itemData = item.data;
                    if (itemData.type !== 'other') {
                        selectedList.push(itemData);
                    }
                }
                else {
                    const leafChildren = item.children;
                    leafChildren.forEach(leaf => {
                        if (leaf.data.type !== 'other') {
                            selectedList.push(leaf.data);
                        }
                    });
                }
            });
        }
        else if (orgList === null || orgList === void 0 ? void 0 : orgList.length) {
            idList = util.getKeyListByList(orgList, 'id');
        }
        else {
            const { orgList: list } = await contactApi.doGetContactOrg({
                orgId: key,
                showDisable: false,
                _account,
            });
            idList = util.getKeyListByList(list, 'id');
        }
        if (multiple) {
            const { contactItem, selectContactItem } = await getSelectedItemBySelectOrg({
                checked: true,
                idList,
                selectedMap: selectedMap,
                selectedList,
                useContactId,
                disabledMap,
                _account,
            });
            setSelectedMap(contactItem);
            setSelectOrgLoading(false);
            onContactSelect && onContactSelect([...contactItem.values()], selectContactItem);
        }
        else {
            const { contactItem } = await getSelectedItemBySelectOrg({
                checked: true,
                idList,
                selectedMap: new Map(),
                selectedList,
                useContactId,
                _account,
            });
            const list = [...contactItem.values()];
            setSelectOrgLoading(false);
            onContactSelect && onContactSelect(list, list);
        }
    };
    const handleLoadPersonalMarkData = useCallback(async () => {
        const _personalMarkList = await initPersonalMarkList();
        let personalMarkChildren = [];
        _personalMarkList.forEach(item => {
            if (item) {
                if ('orgType' in item) {
                    personalMarkChildren.push(transOrgItem2TreeNode(item, !showContact));
                }
                else {
                    personalMarkChildren.push(transTreeLeaf({ item, parentKey: StaticNodeKey.PERSON_MARK_LIST }));
                }
            }
        });
        return personalMarkChildren;
    }, []);
    const insertChildrenToParentNode = (node, children) => {
        const { nodeType, key } = node;
        const oldTreeData = treeDataMap[nodeType];
        if (oldTreeData) {
            if (!children.length && showNoDataPlaceholder && showContact) {
                const externalData = {
                    type: 'other',
                    id: key + '_noData',
                    email: '',
                    name: transTreeName('noContact'),
                };
                children = [transTreeLeaf({ item: externalData })];
            }
            const tree = updateOrgTreeDataV2({
                data: oldTreeData,
                key,
                child: children,
                noChildToLeaf: true,
                item: node,
            });
            updateTreeMap(nodeType, tree, false);
        }
    };
    const handleLoadDataTeam = async (node) => {
        const { key } = node;
        let leafData = [];
        const memberList = (await getTeamMembers([key], false));
        memberList.forEach(item => {
            if (item.model) {
                leafData.push(transTreeLeaf({ item: item.model, parentKey: StaticRootNodeKey.TEAM }));
            }
        });
        insertChildrenToParentNode(node, leafData);
    };
    const handleLoadDataCustomer = async (node) => {
        const { key, page = 0 } = node;
        let leafData = [];
        if (key === StaticRootNodeKey.CUSTOMER) {
            const res = await loadCustomerData({ page: page + 1 });
            leafData = res.children;
            node.hasMore = res.hasMore;
            node.page = res.page;
        }
        else {
            const res = await loadCustomerContactData({ page: page + 1, id: key });
            leafData = res.children;
            node.hasMore = res.hasMore;
            node.page = res.page;
        }
        insertChildrenToParentNode(node, leafData);
    };
    const handleLoadDataPersonal = async (node) => {
        const { key } = node;
        let leafData = [];
        if (key === StaticNodeKey.PERSON_MARK_LIST) {
            leafData = await handleLoadPersonalMarkData();
        }
        else {
            const contactList = await contactApi.doGetContactByOrgId({ orgId: key, _account });
            contactList.forEach(model => {
                leafData.push(transTreeLeaf({ item: model, parentKey: key }));
            });
        }
        insertChildrenToParentNode(node, leafData);
    };
    const handleLoadDataEnterprise = async (node) => {
        var _a;
        const { key, data } = node;
        let leafData = [];
        let curNodeChildren = [];
        if (orgModel && orgModel[key]) {
            curNodeChildren = (_a = orgModel[key].children) === null || _a === void 0 ? void 0 : _a.filter(c => !excludeOrgTypeSet.has(c.type)).map(item => transTreeNode(item));
            if ((data === null || data === void 0 ? void 0 : data.type) === 1) {
                curNodeChildren.sort((a, b) => {
                    var _a, _b;
                    const orgRankA = (_a = a.data) === null || _a === void 0 ? void 0 : _a.orgRank;
                    const orgRankB = (_b = b.data) === null || _b === void 0 ? void 0 : _b.orgRank;
                    const rankA = orgRankA === 0 ? Number.MAX_SAFE_INTEGER : orgRankA || 0;
                    const rankB = orgRankB === 0 ? Number.MAX_SAFE_INTEGER : orgRankB || 0;
                    return rankA - rankB;
                });
            }
        }
        const curTreeChildren = [];
        if (showContact) {
            const contactList = await contactApi.doGetContactByOrgId({ orgId: key, _account });
            const opertionMethod = (data === null || data === void 0 ? void 0 : data.type) === 1 ? 'unshift' : 'push';
            contactList.forEach(model => {
                curTreeChildren[opertionMethod](transTreeLeaf({ item: model, parentKey: key, isMailList: (data === null || data === void 0 ? void 0 : data.type) === 2 }));
            });
        }
        leafData = [...curNodeChildren, ...curTreeChildren];
        insertChildrenToParentNode(node, leafData);
    };
    const handleLoadData = async (node) => {
        const { nodeType } = node;
        if (nodeType === 'team' && showContact) {
            await handleLoadDataTeam(node);
            return;
        }
        if (nodeType === 'customer' && showContact) {
            await handleLoadDataCustomer(node);
            return;
        }
        if (nodeType === 'enterprise') {
            await handleLoadDataEnterprise(node);
            return;
        }
        if (nodeType === 'personal' && showContact) {
            await handleLoadDataPersonal(node);
        }
    };
    const handleLoadMoreData = async (node) => {
        const { hasMore, nodeType } = node;
        if (nodeType === 'customer' && hasMore) {
            await handleLoadDataCustomer(node);
        }
    };
    const handleMemberList = (contact) => {
        if (JSON.stringify(contact) === '{}')
            return;
        setShowMemberList(true);
        setCurrentContact(contact);
    };
    const closeModelMed = useCallback(() => {
        setShowMemberList(false);
    }, [setShowMemberList]);
    const renderTitle = (data) => {
        const { data: contact, title, isMailList: _isMailList, nodeType } = data;
        if (nodeType === 'other') {
            return (React.createElement("span", { className: styles.leafWrapContainer },
                React.createElement("div", { className: classnames(styles.contactTreeLeafWrap, styles.contactTreeNode, styles.contactTreeNoData) }, title)));
        }
        const email = contact.email;
        const contactItemKey = getContactItemKey(contact, useContactId);
        const checked = selectedMap.has(contactItemKey);
        const disabled = disabledMap.has(contactItemKey);
        const isMailList = _isMailList || (contact.accountType !== undefined && contactApi.isMailListByAccountType(contact.accountType));
        const visiblePersonalMark = showPersonalMark && contact.type === 'personal';
        return (React.createElement("span", { className: styles.leafWrapContainer },
            React.createElement(Tooltip, { title: email, mouseEnterDelay: 1 },
                React.createElement("div", { "data-test-id": "tree_leaf", className: classnames(styles.contactTreeLeafWrap, styles.contactTreeNode, {
                        [styles.noAvatar]: !showAvatar,
                        [styles.leafWrapMail]: isMailList,
                    }) },
                    showCheckbox && (React.createElement("div", { className: styles.treeLeafCheckbox },
                        React.createElement(Checkbox, { checked: checked, disabled: disabled }))),
                    showAvatar ? (React.createElement("div", { className: styles.contactTreeAvatar },
                        React.createElement(AvatarTag, { contactId: contact === null || contact === void 0 ? void 0 : contact.id, user: { email, name: contact.name, avatar: contact.avatar } }))) : (React.createElement(React.Fragment, null)),
                    React.createElement("span", { className: classnames(styles.contactTreeTitleTxt, disabled && styles.disabled) }, title),
                    visiblePersonalMark && React.createElement(PersonalMark, { email: email, contactId: contact.id, canOperate: true, cancelToast: true, visibleHover: true }),
                    renderTitleSuffix && renderTitleSuffix(data, _account))),
            showMailListEye && isMailList ? (React.createElement("div", { className: classnames({
                    [styles.orgSelectMail]: isMailList,
                }), "data-test-id": "tree_leaf_btn_mailList", onClick: e => {
                    e.stopPropagation();
                    if (contact) {
                        handleMemberList(contact);
                    }
                } },
                React.createElement(Tooltip, { title: transTreeName('memberList'), placement: "bottom" },
                    React.createElement(Space, null,
                        React.createElement(EyeOutlined, { rev: undefined }))))) : null));
    };
    const nodeTitleRender = useCallback((type, title) => {
        const typeRootTitle = {
            recentRoot: (React.createElement(React.Fragment, null,
                title,
                React.createElement(Tooltip, { placement: "bottomRight", overlayClassName: styles.recentTooltipArrow, destroyTooltipOnHide: { keepParent: false }, arrowPointAtCenter: true, title: transTreeName('rencentSendMail'), overlayStyle: { maxWidth: '100%' } },
                    React.createElement("span", { className: `dark-invert ${styles.orgTitleSvg}`, style: { marginLeft: 5 } },
                        React.createElement(InfoCircleOutlined, { rev: undefined }))))),
            teamRoot: (React.createElement(ProductAuthTag, { tagName: ProductTagEnum.EMAIL_RECEIVER_IM_GROUP, flowTipStyle: { top: '-8px', verticalAlign: 'middle' } }, title)),
        };
        const titleRender = titleRenderMap && titleRenderMap[type];
        if (titleRender) {
            return titleRender(title);
        }
        return typeRootTitle[type] || title;
    }, [titleRenderMap]);
    const getTestId = useCallback((key, nodeType, data) => {
        const defalutIds = {
            [StaticRootNodeKey.PERSON]: 'tree_personalRoot',
            [StaticRootNodeKey.ENTERPRISE]: 'tree_enterpriseRoot',
            [StaticRootNodeKey.TEAM]: 'tree_teamRoot',
            [StaticRootNodeKey.RECENT]: 'tree_recentRoot',
            [StaticNodeKey.PERSON_ALL]: 'tree_personalAll',
            [StaticNodeKey.PERSON_NO_GROUP]: 'tree_personalNoGroup',
            [StaticNodeKey.PERSON_MARK_LIST]: 'tree_personalMark',
        };
        if (defalutIds[key]) {
            return defalutIds[key];
        }
        if (nodeType === 'personal') {
            return 'tree_personalOrg';
        }
        if (nodeType === 'enterprise' && (data === null || data === void 0 ? void 0 : data.type) === 2) {
            return 'tree_org_mailList';
        }
        return 'tree_org';
    }, []);
    const getCountTestId = useCallback((key) => {
        if (key === StaticNodeKey.PERSON_ALL) {
            return 'tree_personalAll_count';
        }
        else if (key === StaticNodeKey.PERSON_MARK_LIST) {
            return 'tree_personalMark_count';
        }
        else if (key === StaticNodeKey.PERSON_NO_GROUP) {
            return 'tree_personalNoGroup_count';
        }
        else {
            return 'tree_personalOrg_count';
        }
    }, []);
    const renderNode = (item) => {
        var _a, _b;
        const { data, nodeType, title, key, titleToolTip } = item;
        const isTeam = nodeType === 'team';
        const isPersonalOrg = nodeType === 'personal';
        const isOrg = nodeType === 'enterprise';
        const teamInfo = data;
        const btnName = selectBtnNameMap[nodeType];
        const visibleOrgBtn = showAddOrgBtn && isOrg && !rootKey.includes(key);
        const visibleTeamBtn = showAddTeamBtn && isTeam && !rootKey.includes(key);
        const personalOrgBlackList = useOrgUnit ? [...rootKey, StaticNodeKey.PERSON_ALL, StaticNodeKey.PERSON_NO_GROUP] : rootKey;
        const visiblePersonalOrgBtn = isPersonalOrg && showAddPersonalBtn && !personalOrgBlackList.includes(key);
        const visibleSelectBtn = btnName && (visibleOrgBtn || visibleTeamBtn || visiblePersonalOrgBtn);
        const visiblePersonalCount = isPersonalOrg && key !== StaticRootNodeKey.PERSON;
        const personalCount = (_a = personalOrgMap.get(key)) === null || _a === void 0 ? void 0 : _a.size;
        const visibleEnterpriseCount = showOrgMemberNum && item.nodeType === 'enterprise' && item.isOrg;
        let enterpriseCount = ((_b = item === null || item === void 0 ? void 0 : item.data) === null || _b === void 0 ? void 0 : _b.memberNum) || 0;
        const disabled = disabledMap.has(key);
        const visiblePersonalMark = showPersonalMark && isPersonalOrg && !personalMarkKeyBlackList.includes(key);
        const dataTestId = getTestId(key, nodeType, data);
        const personalCountId = getCountTestId(key);
        if (key === 'enterpriseRoot' && showOrgMemberNum && lodashGet(item, 'data.memberNum', 0) === 0) {
            enterpriseCount = (item.children || []).reduce((total, current) => {
                const childNum = lodashGet(current, 'data.memberNum', 0);
                return total + childNum;
            }, 0);
        }
        const renderNodeTitle = () => {
            if (treeRootKey.includes(key)) {
                return nodeTitleRender(key, React.createElement("div", { className: styles.orgTitle }, title));
            }
            else {
                return React.createElement("div", { className: styles.orgTitle }, title);
            }
        };
        return (React.createElement(React.Fragment, null,
            React.createElement(Tooltip, { title: titleToolTip || title, mouseEnterDelay: 1, destroyTooltipOnHide: { keepParent: false }, overlayClassName: 'overlay-' + key },
                React.createElement("div", { "data-test-id": dataTestId, className: classnames(styles.orgWrap, styles.contactTreeNode, {
                        [styles.orgWrapRecentRoot]: key === StaticRootNodeKey.RECENT,
                    }) },
                    renderNodeTitle(),
                    isTeam && key !== StaticRootNodeKey.TEAM && React.createElement("div", { className: styles.orgTitleLabel }, `（${teamInfo === null || teamInfo === void 0 ? void 0 : teamInfo.memberNum}人）`),
                    visiblePersonalCount && React.createElement("div", { className: styles.orgTitleLabel, "data-test-id": personalCountId }, `（${personalCount || 0}）`),
                    visiblePersonalMark && (React.createElement(PersonalMark, { testId: "tree_personalOrg_persoanlMark_icon", style: { marginRight: 24 }, orgId: key, canOperate: true, cancelToast: true, visibleHover: true, onMarked: marked => onMarked && onMarked(marked, item) })),
                    visibleEnterpriseCount && React.createElement("div", { className: styles.orgTitleLabel },
                        "(",
                        enterpriseCount,
                        ")"),
                    React.createElement("span", null,
                        React.createElement(Button, { hidden: !visibleSelectBtn, disabled: disabled, loading: selectOrgLoading, "data-test-id": "tree_selectOrg_btn", className: classnames(styles.orgSelect, disabled && styles.orgSelectDisabled), onClick: e => {
                                e.stopPropagation();
                                !disabled && handleSelectOrg(item);
                            } },
                            React.createElement("span", { hidden: selectOrgLoading }, btnName))),
                    renderTitleSuffix && renderTitleSuffix(item, _account)))));
    };
    const accountTreeData = useMemo(() => {
        const showAccountRootKey = Boolean(rootTitle && accountRootKey);
        const treeData = transTreeMap2TreeData(treeDataMap, order);
        if (showAccountRootKey) {
            const accountIcon = accountType ? mailIconList.get(accountType) || mailIconList.get('Others') : React.createElement(React.Fragment, null);
            return [
                {
                    key: accountRootKey,
                    title: (React.createElement("div", { className: styles.rootKeyWrap },
                        React.createElement("div", { className: styles.rootKeyIcon }, accountIcon),
                        React.createElement("div", { className: styles.rootKeyName }, rootTitle))),
                    isLeaf: false,
                    isOrg: true,
                    nodeType: 'root',
                    titleToolTip: rootTitle,
                    children: treeData,
                },
            ];
        }
        return treeData;
    }, [accountType, rootTitle, accountRootKey, treeDataMap, order]);
    const visibleTree = useMemo(() => {
        var _a;
        const enterpriseData = treeDataMap.enterprise && treeDataMap.enterprise[0];
        const hasEnterpriseData = enterpriseData && enterpriseData.children && enterpriseData.children.length > 0;
        const personalSize = (_a = personalOrgMap.get(StaticNodeKey.PERSON_ALL)) === null || _a === void 0 ? void 0 : _a.size;
        return !loading || !isSingleAccount || hasEnterpriseData || (personalSize && personalSize > 0);
    }, [treeDataMap, isSingleAccount, loading, personalOrgMap]);
    const refreshTreeDecorate = useCallback(() => {
        const filterKeyList = [StaticNodeKey.PERSON_ALL, StaticNodeKey.PERSON_NO_GROUP, StaticNodeKey.PERSON_MARK_LIST];
        const hasPersonalOrg = [...personalOrgMap.keys()].some(item => !filterKeyList.includes(item));
        setDecorateRenderMap(_data => {
            let hasModify = false;
            const cloneDecorateRenderMap = new Map(_data);
            if (cloneDecorateRenderMap.size) {
                cloneDecorateRenderMap.forEach(item => {
                    if (item.has('personalTip')) {
                        const personalTipData = item.get('personalTip');
                        if ((personalTipData === null || personalTipData === void 0 ? void 0 : personalTipData.show) && (hasPersonalOrg || !isSingleAccount)) {
                            hasModify = true;
                            item.set('personalTip', Object.assign(Object.assign({}, personalTipData), { show: !hasPersonalOrg }));
                        }
                    }
                    if (item.has('enterpriseRenderDivider')) {
                        const enterpriseRenderDividerData = item.get('enterpriseRenderDivider');
                        if ((enterpriseRenderDividerData === null || enterpriseRenderDividerData === void 0 ? void 0 : enterpriseRenderDividerData.show) && !isSingleAccount) {
                            hasModify = true;
                            item.set('enterpriseRenderDivider', Object.assign(Object.assign({}, enterpriseRenderDividerData), { show: false }));
                        }
                    }
                });
            }
            if (hasModify) {
                return cloneDecorateRenderMap;
            }
            return _data;
        });
    }, [personalOrgMap, isSingleAccount]);
    useEffect(() => {
        refreshTreeDecorate();
    }, [personalOrgMap]);
    useEffect(() => {
        setDecorateRenderMap(new Map(contactTreeDecorateMap));
        refreshTreeDecorate();
    }, [contactTreeDecorateMap]);
    const cardGroupDecorate = useMemo(() => {
        if (!decorateRenderMap.size) {
            return undefined;
        }
        else {
            return [
                (keys) => {
                    const decorateList = [];
                    keys.forEach((key, index) => {
                        const renderKey = key;
                        const renderEleList = decorateRenderMap.get(renderKey);
                        if (index - 1 >= 0 && (renderEleList === null || renderEleList === void 0 ? void 0 : renderEleList.size)) {
                            renderEleList.forEach(item => {
                                const { element, height, distance = 0, show = true } = item;
                                if (show) {
                                    decorateList.push({
                                        element,
                                        index: index + distance,
                                        height,
                                    });
                                }
                            });
                        }
                    });
                    return decorateList;
                },
            ];
        }
    }, [decorateRenderMap]);
    const handleSelectNode = (nodeData) => {
        if (onSelectNode && !treeRootKey.includes(nodeData.key)) {
            onSelectNode(nodeData, _account);
        }
    };
    const handleSelect = async (nodeData) => {
        if (!nodeData.isOrg) {
            if (nodeData.nodeType === 'other') {
                return;
            }
            handleSelectNode(nodeData);
            if (!showContact) {
                return;
            }
            const { data: contact } = nodeData;
            const key = getContactItemKey(contact, useContactId);
            if (disabledMap.has(key)) {
                return;
            }
            if (multiple) {
                const isSelected = selectedMap.has(key);
                isSelected ? selectedMap.delete(key) : selectedMap.set(key, contact);
                setSelectedMap(selectedMap);
                renderTree();
                onContactSelect && onContactSelect([...selectedMap.values()], [contact]);
            }
            else {
                onContactSelect && onContactSelect([contact], [contact]);
            }
        }
        else {
            handleSelectNode(nodeData);
        }
    };
    const handleExpand = async (nodeData) => {
        var _a;
        if (nodeData.key === 'recentRoot' && !expandedKeys.has(nodeData.key) && !((_a = nodeData.children) === null || _a === void 0 ? void 0 : _a.length)) {
            await initRecent().then(() => _inited('recent'));
        }
        const { key, nodeType } = nodeData;
        if (expandedKeys.has(key)) {
            onExpand && onExpand(nodeType, false);
            expandedKeys.delete(key);
        }
        else {
            onExpand && onExpand(nodeType, true);
            expandedKeys.add(key);
        }
        console.log('handleSelect', expandedKeys);
        setExpandedKeys(new Set([...expandedKeys]));
    };
    const renderTree = useCallback(() => {
        console.warn('[contact_tree] renderTree');
        setTreeDataMap(data => (Object.assign({}, data)));
    }, []);
    return (React.createElement("div", { className: styles.ContactTree, "data-test-id": "contact_tree" },
        visibleTree && (React.createElement(Tree, { rootClassName: styles.reallyTree, selectedKeys: selectedKeys, hasMore: false, scrollToIndex: 0, width: treeWidth, height: treeHeight, realSize: !isSingleAccount, onLoadMoreNode: async (_, parentNode) => {
                await handleLoadMoreData(parentNode);
                return true;
            }, loadData: async (data) => {
                await handleLoadData(data);
                return true;
            }, selectAndExpand: true, defaultExpandedKeys: [...(expandedKeys || [])], expandedKeys: [...(expandedKeys || [])], onSelect: (_, { node }) => {
                handleSelect(node);
            }, onRightClick: ({ node }) => {
                if (onContextMenu) {
                    onContextMenu(node, _account);
                }
            }, onExpand: (_, { node }) => {
                handleExpand(node);
            }, treeData: accountTreeData, titleRender: data => {
                const nodeData = data;
                if (nodeData.isOrg) {
                    return renderNode(nodeData);
                }
                else {
                    return renderTitle(nodeData);
                }
            }, icon: null, cardGroupDecorate: cardGroupDecorate })),
        !visibleTree && (React.createElement(Skeleton, { loading: loading, active: true, title: false, paragraph: { rows: 6 }, avatar: false },
            React.createElement("div", { className: styles.empty },
                React.createElement("div", { className: styles.emptyTxt }, transTreeName('notVisible')),
                React.createElement("div", { className: styles.emptyTxt }, transTreeName('contactAdmin'))))),
        showMemberList && currentContact && (React.createElement(MemberList, { visible: showMemberList, user: currentContact.email, _account: _account, contactName: currentContact.name, onCancel: closeModelMed }))));
};
export default AccountTree;
